import { render, staticRenderFns } from "./DeleteProfile.vue?vue&type=template&id=58714f76&scoped=true&"
import script from "./DeleteProfile.vue?vue&type=script&lang=js&"
export * from "./DeleteProfile.vue?vue&type=script&lang=js&"
import style0 from "./DeleteProfile.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DeleteProfile.vue?vue&type=style&index=1&id=58714f76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58714f76",
  null
  
)

export default component.exports